<template>
  <div class="row">
    <div class="col-12">
      <card class="custom-shadow-card-header">
        <div class="row content-add-btn">
          <div class="col-4" v-if="isCreate()">
            <div class="text-left">
              <button
                class="btn btn-secondary custom-shadow-btn"
                @click="openModal('create')"
              >
                <em class="fa fa-plus"></em>
                {{ $t('irrigation.energy_source_add') }}
              </button>
            </div>
          </div>
          <div class="col-12 text-center">
            <hr />
          </div>
          <el-dialog
            v-if="isShow()"
            :title="nameAreasSelected"
            :visible.sync="modals.read"
            width="51%"
          >
            <p>
              {{ $t('common_words.selected_record_info') }}
            </p>
            <div class="card">
              <div class="card-body">
                <table class="table">
                  <tbody>
                    <tr class="shadow-sm">
                      <td>
                        <h6>
                          <strong>{{ $t('irrigation.energy_source') }}:</strong>
                        </h6>
                        {{ rowData.name }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer footer-date-at">
                <p class="text-white">
                  <small
                    >{{ $t('common_words.created_on') }}:
                    {{ rowData.created_at }}</small
                  >
                </p>
              </div>
            </div>
          </el-dialog>
          <el-dialog :title="title" :visible.sync="modals.create">
            <form>
              <div class="row">
                <div class="col-12">
                  <fg-input
                    type="text"
                    :label="`${$t('irrigation.energy_source')} *`"
                    v-model="energySourceFrom.name"
                    name="irrigation.energy_source"
                    v-validate="modelValidations.name"
                    :error="getError('irrigation.energy_source', true)"
                    :placeholder="`${$t('irrigation.energy_source')}...`"
                  >
                  </fg-input>
                </div>
              </div>
            </form>
            <span slot="footer" class="dialog-footer">
              <button
                class="btn btn-danger custom-shadow-btn"
                @click="closeModal('create')"
              >
                {{ $t('common_words.cancel') }}</button
              >&nbsp;
              <button
                class="btn custom-btn-success custom-shadow-btn"
                @click="validate"
              >
                {{ $t('common_words.confirm') }}
              </button>
            </span>
          </el-dialog>
        </div>
        <div v-if="isIndex()">
          <div
            class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
          >
            <el-select
              clearable
              @clear="pagination.perPage = 10"
              class="select-default mb-3 shadow-sm"
              style="width: 200px"
              v-model="pagination.perPage"
              :placeholder="$t('common_words.per_page')"
              filterable
            >
              <el-option
                class="select-default"
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            <el-input
              clearable
              class="mb-3 shadow-sm"
              style="width: 200px"
              :placeholder="$t('common_words.search_records')"
              v-model="searchQuery"
              aria-controls="datatables"
            />
          </div>
          <div class="col-sm-12">
            <el-table
              stripe
              :default-sort="{ prop: 'name', order: 'descending' }"
              style="width: 100%"
              :data="queriedData"
              :border="true"
            >
              <el-table-column type="index" width="65"></el-table-column>
              <el-table-column
                v-for="column in tableColumns"
                :key="column.label"
                :min-width="column.minWidth"
                :prop="column.prop"
                :label="column.label"
                :render-header="renderHeader"
              ></el-table-column>
              <el-table-column
                :min-width="110"
                :label="$t('common_words.operations')"
                fixed="right"
              >
                <template slot-scope="props">
                  <div class="text-center">
                    <a
                      v-if="isShow()"
                      v-tooltip.top-center="$t('common_words.view')"
                      class="btn-info btn-simple btn-link custom-margin-actions"
                      @click="handleView(props.$index, props.row)"
                    >
                      <em class="fa fa-eye custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isUpdate()"
                      v-tooltip.top-center="$t('common_words.edit')"
                      class="btn-warning btn-simple btn-link custom-margin-actions"
                      @click="handleEdit(props.$index, props.row)"
                    >
                      <em class="fa fa-edit custom-size-fa-actions"></em>
                    </a>
                    <a
                      v-if="isDelete()"
                      v-tooltip.top-center="$t('common_words.erase')"
                      class="btn-danger btn-simple btn-link custom-margin-actions"
                      @click="handleDelete(props.$index, props.row)"
                    >
                      <em class="fa fa-times custom-size-fa-actions"></em>
                    </a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div v-else>
          <br />
          <h5 class="text-muted text-center">
            {{ $t('common_words.no_permissions') }}
          </h5>
        </div>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class>
            <p class="card-category">
              {{ $t('table2.showing') }} {{ from + 1 }} {{ $t('table2.a') }}
              {{ to }} {{ $t('table2.of') }} {{ total }}
              {{ $t('table2.entries') }}
            </p>
          </div>
          <l-pagination
            class="pagination-no-border"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            pageFirst="false"
            pageLast="false"
          ></l-pagination>
        </div>
      </card>
      <div class="row" style="padding-right: 13px; padding-left: 13px">
        <div class="col-6" v-if="isPDF()">
          <div class="text-right">
            <button
              class="btn btn-danger custom-shadow-btn"
              @click="exportToPDF"
            >
              <em class="fa fa-file-pdf-o"></em>
              {{ $t('common_words.export_to_pdf') }}
            </button>
          </div>
        </div>
        <div class="col-6" v-if="isExcel()">
          <div class="text-left">
            <button
              class="btn custom-btn-success custom-shadow-btn"
              @click="exportToExcel"
            >
              <em class="fa fa-file-excel-o"></em>
              {{ $t('common_words.export_to_excel') }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Fuse from 'fuse.js';
import moment from 'moment';
import SweetAlert from 'src/class/Alerts';
import configTable from './paginationData';
import mixinMasters from 'src/util/mixinMasters';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinPermissions from 'src/util/mixinPermissions';
import { Pagination as LPagination } from 'src/components/index';
import { MixinNotification } from 'src/mixins/mixin-notification.js';
import { MixinExport } from 'src/mixins/mixin-export';
import { Axios } from 'src/class/Axios.js';
import MixinMenu from 'src/util/mixinMenu';
import i18n from 'src/i18n';

export default {
  components: {
    LPagination,
  },

  computed: {
    ...configTable().Search,
  },

  data() {
    return {
      energySourceFrom: {},
      rowData: {},
      tableData: [],
      searchQuery: '',
      fuseSearch: null,
      pagination: {},
      tableColumns: [],
      modelValidations: {
        name: {
          required: true,
        },
      },
    };
  },

  mixins: [
    mixinMasters,
    MixinPermissions,
    MixinNotification,
    MixinExport,
    MixinForm,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': 'setupTable',
  },

  methods: {
    openModal(name) {
      if (name == 'create') {
        this.title = i18n.t('irrigation.energy_source_add');
        this.$validator.reset();
        this.energySourceFrom = {};
      }

      this.modals[name] = true;
    },

    renderHeader(h, { column }) {
      return h('div', [
        h('span', column.label.split('-')[0]),
        h('br'),
        h('span', column.label.split('-')[1]),
      ]);
    },

    validate() {
      return this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (this.isCreate() && !sessionStorage.getItem('editForm')) {
            this.createEnergySource();
          } else if (this.isUpdate() && sessionStorage.getItem('editForm')) {
            this.updateEnergySource();
          }
        }
      });
    },

    createEnergySource() {
      this.showHideLoading(true);
      this.energySourceFrom.route = 'irrigation/energysources';
      Axios.saveMaster(this.energySourceFrom)
        .then((response) => {
          this.modifyTable(0, null, response);
        })
        .catch((error) => {
          this.closeModal('create');
          this.showNotification(
            `${error.response.data.message}`,
            'danger',
            'nc-simple-add',
            `${i18n.t('common_words.alert')}...`
          );
          this.showHideLoading();
        });
    },

    updateEnergySource() {
      this.energySourceFrom.route = 'irrigation/energysources';
      this.energySourceFrom.id = JSON.parse(
        sessionStorage.getItem('editForm')
      ).id;
      Axios.updateMaster(this.energySourceFrom)
        .then((response) => {
          this.modifyTable(1, this.energySourceFrom.id, response);
          sessionStorage.removeItem('editForm');
        })
        .catch((error) => {
          this.closeModal('create');
          this.showNotification(
            `${error.response.data.message}`,
            'danger',
            'nc-simple-add',
            `${i18n.t('common_words.alert')}...`
          );
          this.showHideLoading();
          sessionStorage.removeItem('editForm');
        });
    },

    handleView(index, row) {
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.modals['read'] = true;
    },

    handleEdit(index, row) {
      sessionStorage.setItem('editForm', JSON.stringify(row));
      this.rowData = row;
      this.rowData.created_at = moment(
        String(this.rowData.created_at),
        'YYYY-MM-DD HH:mm:ss'
      ).format('YYYY-MM-DD hh:mm:ss');
      this.title = i18n.t('irrigation.energy_source_edit') + row.name;
      this.energySourceFrom = Object.assign({}, row);
      this.errors.clear();

      this.modals['create'] = true;
    },

    deleteEnergySource() {
      this.showHideLoading(true);
      this.energySourceFrom.route = 'irrigation/energysources';
      Axios.destroyMaster(this.energySourceFrom)
        .then((response) =>
          this.modifyTable(2, this.energySourceFrom.id, response)
        )
        .catch((error) => {
          this.showHideLoading();
          SweetAlert.danger(
            error.response.data.message ? error.response.data.message : error
          );
        });
    },

    handleDelete(index, row) {
      this.energySourceFrom = row;
      SweetAlert.delete(this.energySourceFrom.name).then((result) => {
        if (result.value) this.deleteEnergySource();
      });
    },

    exportToPDF() {
      let data = {};
      data.route = 'irrigation/energysources/pdf';
      data.name_file = `${i18n.t('irrigation.energy_sources')}.pdf`;

      this.PDF(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },

    exportToExcel() {
      let data = {};
      data.route = 'irrigation/energysources/excel';
      data.name_file = `${i18n.t('irrigation.energy_sources')}.xlsx`;

      this.Excel(data)
        .then(() => {
          this.showDownloadNotification();
        })
        .catch((error) => this.showMessageErrors(error));
    },
    setupTable() {
      const { Table } = configTable();
      this.tableColumns = Table.tableColumns;
      this.pagination = { ...Table.pagination };
    },
  },

  //    updated(){
  //      sessionStorage.removeItem("editForm");
  //    },

  created() {
    if (this.isIndex()) {
      this.setupTable();
      this.showHideLoading(true);

      Axios.getMasters('irrigation/energysources')
        .then((response) => {
          this.tableData = response.data.data;
          this.fuseSearch = new Fuse(this.tableData, {
            useExtendedSearch: true,
            threshold: 0.3,
            keys: this.tableColumns.map((prop) => {
              return prop.prop;
            }),
          });
          this.showHideLoading();
        })
        .catch((error) => this.showMessageErrors(error));
    } else {
      this.showHideLoading();
    }
  },

  mounted() {
    this.selectedItemOnMenu('irrigation');
  },

  destroyed() {
    this.deselectedItemOnMenu('irrigation');
  },
};
</script>
<style scoped></style>
